import { ITableAdapter } from '../../../../../../generic/universal-table/types/adapter.types'
import {
  PackageApiRow,
  PackageCreatePayload,
  PackageUiRow,
  PackageUpdatePayload,
} from '../types/packageTable.types'

export const packageTableAdapter: ITableAdapter<
  PackageApiRow,
  PackageUiRow,
  PackageCreatePayload,
  PackageUpdatePayload
> = {
  fromApi: (row: PackageApiRow): PackageUiRow => ({
    PackID: row.PackID,
    Pack_Name: row.Pack_Name?.trim() ?? '',
    Pack_Type: row.Pack_Type?.trim() ?? '',
    SupplierID: row.SupplierID ?? 0,
    Catalog_Number: row.Catalog_Number?.trim() ?? '',
    Pack_Size: row.Pack_Size?.trim() ?? '',
    Eng_Desc: row.Eng_Desc?.trim() ?? '',
    Main_PackID: row.Main_PackID ?? 0,
    Pack_Price: row.Pack_Price ?? 0,
    Export_Weight: row.Export_Weight ?? 0,
    Qty4Pallets: row.Qty4Pallets ?? 0,
    Tare_Weight: row.Tare_Weight ?? 0,
    Volume: row.Volume ?? 0,
    Cooling_Fee: row.Cooling_Fee ?? 0,
    Credit_Fee: row.Credit_Fee ?? 0,
    Usage_Fee: row.Usage_Fee ?? 0,
    Active: row.Active ?? false,
    DepositWithVAT: row.DepositWithVAT ?? false,
    Download_from_Warehouse: row.Download_from_Warehouse ?? false,
    Inventory: row.Inventory ?? false,
    Providence: row.Providence ?? false,
    Tranzit_Fee: row.Tranzit_Fee ?? false,
  }),

  toCreatePayload: ({ PackID: _, ...rest }: PackageUiRow): PackageCreatePayload => rest,

  toUpdatePayload: ({ PackID: _, ...rest }: PackageUiRow): PackageUpdatePayload => rest,

  getRowId: (row: PackageUiRow): number => row.PackID,
}
